import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form, Input, Dropdown } from 'semantic-ui-react';
import { updateData } from '../actions/form';
import ReferenceDropdown from 'common/components/ReferenceDropdown';
import { getErrors } from '../reducers/form';
import RadioOption from '../../../../common/components/RadioOption';

export class Zone extends React.Component {
  render() {
    //Values
    const {
      isOwner,
      constructionDate,
      numberOfFloors,
      annexes,
      buildingType,
      buildingSurface,
      buildingPerimeter,
      landSurface,
      landPerimeter,
      readOnly,
      errors,
    } = this.props;

    //Dispatchers
    const { onOwnerChange } = this.props;

    const buildingTypeChoices = this.props.buildingTypeRefs.filter(
      r => r.deleted === false || r.id === this.props.buildingType
    );

    const annexesChoices = this.props.annexesTypeRefs
      .filter(r => r.deleted === false || annexes.includes(r.id))
      .map(r => ({
        key: r.id,
        value: r.id,
        text: r.label,
      }));

    const hasError = name => {
      return errors.includes(`form.zone.${name}`);
    };

    return (
      <div>
        <RadioOption
          name="owner"
          onChange={onOwnerChange}
          title="Occupants"
          value={isOwner}
          customTrueLabel="Propriétaires"
          customFalseLabel="Locataires"
          customNoneLabel="Non concerné ou ne sais pas"
          readOnly={readOnly}
        />
        <Form.Field>
          <label style={{ fontSize: '1.2em' }}>
            Informations sur le logement
          </label>
          <Form.Group widths="equal">
            <ReferenceDropdown
              refs={buildingTypeChoices}
              onChange={this.props.onBuildingTypeChange}
              title="Type"
              value={buildingType}
              withPlaceholder={false}
              disabled={readOnly}
            />
            <Form.Field
              control={Input}
              label="Année de construction"
              value={constructionDate || ''}
              onChange={this.props.onConstructionDateChange}
              error={hasError('constructionDate')}
              readOnly={readOnly}
            />
            <Form.Field
              control={Input}
              label="Nb de niveaux (hors cave et grenier)"
              value={numberOfFloors || ''}
              onChange={this.props.onNumberOfFloorsChange}
              error={hasError('numberOfFloors')}
              readOnly={readOnly}
            />
            <Form.Field>
              <label>Annexes</label>
              <Dropdown
                selection
                multiple
                value={annexes}
                options={annexesChoices}
                onChange={this.props.onAnnexesChange}
                disabled={readOnly}
              />
            </Form.Field>
          </Form.Group>
        </Form.Field>
        <Form.Field>
          <label style={{ fontSize: '1.2em' }}>Superficies</label>
          <Form.Group widths="equal">
            <Form.Field
              control={Input}
              label="M² bâti"
              required
              value={buildingSurface || ''}
              onChange={this.props.onBuildingSurfaceChange}
              error={hasError('buildingSurface')}
              readOnly={readOnly}
            />
            <Form.Field
              control={Input}
              label="Périmètre bâti"
              value={buildingPerimeter || ''}
              onChange={this.props.onBuildingPerimeterChange}
              error={hasError('buildingPerimeter')}
              readOnly={readOnly}
            />
            <Form.Field
              control={Input}
              label="M² terrain"
              required
              value={landSurface || ''}
              onChange={this.props.onLandSurfaceChange}
              error={hasError('landSurface')}
              readOnly={readOnly}
            />
            <Form.Field
              control={Input}
              label="Périmètre terrain"
              value={landPerimeter || ''}
              onChange={this.props.onLandPerimeterChange}
              error={hasError('landPerimeter')}
              readOnly={readOnly}
            />
          </Form.Group>
        </Form.Field>
      </div>
    );
  }
}

Zone.propTypes = {
  isOwner: PropTypes.bool,
  buildingType: PropTypes.number,
  constructionDate: PropTypes.string,
  numberOfFloors: PropTypes.string,
  buildingSurface: PropTypes.string,
  buildingPerimeter: PropTypes.string,
  landSurface: PropTypes.string,
  landPerimeter: PropTypes.string,
  annexes: PropTypes.array,

  buildingTypeRefs: PropTypes.array.isRequired,
  annexesTypeRefs: PropTypes.array.isRequired,

  onOwnerChange: PropTypes.func.isRequired,
  onBuildingTypeChange: PropTypes.func.isRequired,
  onConstructionDateChange: PropTypes.func.isRequired,
  onNumberOfFloorsChange: PropTypes.func.isRequired,
  onBuildingSurfaceChange: PropTypes.func.isRequired,
  onBuildingPerimeterChange: PropTypes.func.isRequired,
  onLandSurfaceChange: PropTypes.func.isRequired,
  onLandPerimeterChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isOwner: state.form.form.zone.isOwner,
  buildingType: state.form.form.zone.buildingType,
  constructionDate: state.form.form.zone.constructionDate,
  numberOfFloors: state.form.form.zone.numberOfFloors,
  annexes: state.form.form.zone.annexes,
  accessInformation: state.form.form.zone.accessInformation,
  buildingSurface: state.form.form.zone.buildingSurface,
  buildingPerimeter: state.form.form.zone.buildingPerimeter,
  landSurface: state.form.form.zone.landSurface,
  landPerimeter: state.form.form.zone.landPerimeter,
  errors: getErrors(state),

  buildingTypeRefs: state.requirements.housingTypes,
  annexesTypeRefs: state.requirements.annexes,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onOwnerChange: (_, change) =>
    dispatch(updateData('zone.isOwner', change.value)),
  onBuildingTypeChange: (_, value) =>
    dispatch(updateData('zone.buildingType', value.value)),
  onConstructionDateChange: (_, change) =>
    dispatch(updateData('zone.constructionDate', change.value)),
  onNumberOfFloorsChange: (_, change) =>
    dispatch(updateData('zone.numberOfFloors', change.value)),
  onAnnexesChange: (_, change) =>
    dispatch(updateData('zone.annexes', change.value)),
  onBuildingSurfaceChange: (_, change) =>
    dispatch(updateData('zone.buildingSurface', change.value)),
  onBuildingPerimeterChange: (_, change) =>
    dispatch(updateData('zone.buildingPerimeter', change.value)),
  onLandSurfaceChange: (_, change) =>
    dispatch(updateData('zone.landSurface', change.value)),
  onLandPerimeterChange: (_, change) =>
    dispatch(updateData('zone.landPerimeter', change.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Zone);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Zone.js